import { useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { setQueryString, getQueryParam } from "../../../util/queryParamUtils";

export const useQueryState = (fieldName, defaultValue = "") => {
  const history = useHistory();

  const value = getQueryParam(history, fieldName) || "";
  const setValue = useCallback(
    (newValue) => setQueryString(history, [fieldName, newValue]),
    [fieldName, history]
  );

  // It needs to only run once
  useEffect(() => {
    setValue(value || defaultValue);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return [value, setValue];
};
